export default __webpack_public_path__ + "static/valio_white-eaec97a955045f901adc633a090e9442.png";